export default "__VITE_ASSET__0828029d__"